import { AxiosInstance } from 'axios'
import {
  ConnectorIdentifier, IConnector, IConnectorAuthorization,
  IDataSourceWithConnector
} from '../../../types/connector.types'

// Interface for document metadata
export interface IDocumentPayload {
  id: string;
  file_name: string;
  url?: string;
  body: {
    encoding: 'base64' | 'plain',
    content: string
  }
  contributions?: {
    email: string
    role?: string
    last_activity?: string
  }[]
  ingestion_strategy: string[]
}

export interface IDocumentUploadResult {
  completed: boolean | null,
  connector_id: string,
  created: string,
  end_state: null | string,
  id: string,
  init_state: string,
  updated: string
}


export function connectorsApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/datasources'
  const methods = {
    getDataSources() {
      return api.get<IDataSourceWithConnector[]>(`${baseUrl}/sources`)
    },
    create(identifier: ConnectorIdentifier, baseDomain: string) {
      return api.post<IConnector>(`${baseUrl}/sources/${identifier}/connectors`, { baseDomain })
    },
    getAuthorizationUrl(id: string) {
      return api.get<IConnectorAuthorization>(`${baseUrl}/connectors/${id}/authorization-url`)
    },
    activateConnector(identifier: string) {
      return api.post<IConnector>(`${baseUrl}/connectors/${identifier}/enable`, {})
    },
    uploadDocuments(document: IDocumentPayload) {
      return api.post<IDocumentUploadResult>('/api/v3/knowledge-ingestion/documents', document)
    },
    deleteDocument(id: string) {
      return api.delete<{ success: boolean }>(`/api/v3/knowledge-ingestion/documents/${id}`)
    }
  }
  return methods
}
